<template>
    <x-app light fill-height>
        <x-content fill-height>
            <transition-group
                    id="wrapper"
                    class="fill-height"
                    :class="layout"
                    name="fade"
                    mode="out-in"
                    :is="layout"
            >
                <router-view :key="$route.fullPath" :info="info" :notifications="notifications"/>
            </transition-group>
        </x-content>
    </x-app>
</template>

<script>
    export default {
        name: "App",
        props: ['info', 'notifications'],
        computed: {
            layout() {
                return (this.$route.meta.layout || 'default') + '-layout';
            },
        }
    }
</script>

<style lang="scss" scoped>
    fade-enter-active,
    .fade-leave-active {
        transition-duration: 0.3s;
        transition-property: opacity;
        transition-timing-function: ease;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0
    }

</style>
